export const ACCESSORY_REQUEST = 'accessory_request';
export const ACCESSORY_SUCCESS = 'accessory_success_request';
export const ACCESSORY_ERROR = 'accessory_error_request';
